export enum STEP_TYPE {
  CONVERSATION = 0,
  MCQ = 1,
  FITB = 2,
  MATCHING = 3,
}

export default STEP_TYPE;
